import mitt from 'mitt';

export default () => {

	/**
	 * Create the emitter
	 *
	 * @type {Emitter}
	 */
	// @ts-ignore
	const emitter = mitt();

	/**
	 * Call the event handler once and then remove it
	 *
	 * @param {string} type
	 * @param {CallableFunction} handler
	 */
	emitter.once = (type, handler) => {
		emitter.on(type, function thisHandler(data) {
			emitter.off(type, thisHandler);
			handler(data);
		});
	};

	return emitter;
};
